import { render } from "./CometChatMessageList.vue?vue&type=template&id=3c7557d0"
import script from "./CometChatMessageList.vue?vue&type=script&lang=js"
export * from "./CometChatMessageList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__